import { EntityBinding } from "./BaseEntityRecordBinding";

export const MetadataRegistry = new Map<string, EntityBinding<any>>();
export function MetaBinding(): ClassDecorator {
    return (target) => {
        const binding = target as any as { metadata: () => EntityBinding<any> };
        if (!binding) {
            console.error("MetaBinding: target is not a class");
            return;
        }
        if (typeof binding.metadata != "function") {
            console.error("MetaBinding: target does not have metadata function");
            return;
        }
        const metadata = binding.metadata();
        MetadataRegistry.set(metadata.entityName, metadata);
    };
}
